var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.756 10.901l1.046-1.06c-.807-.068-1.388-.334-1.805-.751C5.842 7.935 5.842 6.3 6.99 5.16l2.27-2.277c1.155-1.149 2.782-1.155 3.937 0 1.162 1.162 1.149 2.789.007 3.937l-1.162 1.156c.219.505.294 1.12.17 1.654l1.956-1.948c1.682-1.675 1.688-4.068-.007-5.763C12.459.217 10.08.23 8.398 1.912L6.02 4.291c-1.681 1.682-1.688 4.067.007 5.763.397.403.944.704 1.73.847zm.635-5.776l-1.045 1.06c.806.075 1.387.335 1.804.752 1.162 1.155 1.155 2.789.007 3.937l-2.27 2.27c-1.155 1.155-2.782 1.155-3.93 0-1.162-1.163-1.155-2.783-.007-3.931L4.105 8.05a2.796 2.796 0 01-.17-1.655L1.978 8.352c-1.681 1.674-1.688 4.06.007 5.755 1.702 1.703 4.081 1.689 5.763.014l2.379-2.386c1.681-1.681 1.688-4.067-.007-5.762-.397-.397-.937-.698-1.73-.848z",
    fill: "#fff"
  })));
}

export default SvgLink;